import { render } from "./ViewClients.vue?vue&type=template&id=8d6f72d0"
import script from "./ViewClients.vue?vue&type=script&lang=js"
export * from "./ViewClients.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__